
import {
  LoggerUtility
} from '../components/ComponentsLibrary';

class ObjectUtility {
  constructor(data = {}) {
    try {
      this.data = data;
    }
    catch (error) {
      LoggerUtility.ManageErrorLogging(error, "ObjectUtility", "ObjectUtility Construtor load");
    }
  }

  setData(data) {
    try {
      this.data = data;
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "ObjectUtility - setData", {});
    }
  }

  getData() {
    try {
      return this.data;
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "ObjectUtility - getData", {});
    }
  }

  addField(fieldPath, fieldName, value) {
    try {
      let target = this.data;

      fieldPath.forEach((key) => {
        if (!target[key]) target[key] = {};
        target = target[key];
      });

      target[fieldName] = value;
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "ObjectUtility - addField", {});
    }
  }

  updateField(fieldPath, newValue) {
    try {
      let target = this.data;

      fieldPath.forEach((key, index) => {
        if (index === fieldPath.length - 1) {
          target[key] = newValue;
        } else {
          target = target[key];
        }
      });
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "ObjectUtility - updateField", {});
    }
  }

  deleteField(fieldPath) {
    try {
      let target = this.data;

      fieldPath.forEach((key, index) => {
        if (index === fieldPath.length - 1) {
          delete target[key];
        } else {
          target = target[key];
        }
      });
    }
    catch (error) {
      throw LoggerUtility.ProcessErrorData(error, "ObjectUtility - deleteField", {});
    }
  }
}

export default ObjectUtility;